import React, { Component } from "react";
import { Modal, Button, Input, Radio, TreeSelect } from "antd";
import "./atlas.css";
import EditorItem from "./editorItem";
import { Scrollbars } from "react-custom-scrollbars";
const { SHOW_PARENT, TreeNode } = TreeSelect;

export default class Editor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      radioValue: 1,
      title: this.props.title,
      value3: this.props.labelNames,
      value4: "单位发布",
      editorColumnList: [],
      accountKey: null,
      pictureList: [],
    };
  }
  showModal = () => {
    this.setState({
      visible: true,
    });
  };
  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };
  // 监听radio
  // radioEventListener() {}
  render() {
    const treeData = JSON.parse(
      JSON.stringify(this.props.filterColumn)
        .replace(/name/g, "title")
        .replace(/id/g, "value")
    );
    const treeData3 = JSON.parse(
      JSON.stringify(this.props.userDate)
        .replace(/name/g, "title")
        .replace(/id/g, "value")
    );

    let pictureList = this.props.pictureList;
    return (
      <div>
        <Modal
          title="编辑图集"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width="1122px"
          bodyStyle={{ height: "722px" }}
          footer={null}
        >
          <div className="imgPublic">
            <h1>图集发布</h1>
          </div>
          {/* 图片列表 */}
          <div style={{ height: "250px" }}>
            <Scrollbars>
              {pictureList.map((item, index) => {
                return (
                  <EditorItem
                    key={index}
                    desc={item.desc}
                    path={item.path}
                    myClick={() => this.delete(index)} //删除
                  />
                );
              })}
            </Scrollbars>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "10px",
            }}
          >
            <Button type="primary" size="large">
              添加图片
            </Button>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "30px",
              marginLeft: "30px",
            }}
          >
            <div>*</div>
            <div
              style={{
                margin: "0 20px 0 0",
                width: "40px",
                textAlign: "center",
              }}
            >
              标题
            </div>

            <Input
              style={{ marginLeft: "5px" }}
              value={this.state.title}
              onChange={(e) => this.titleChange(e)}
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "30px",
              marginLeft: "30px",
            }}
          >
            <div
              style={{
                margin: "0 20px 0 5px",
                width: "40px",
                textAlign: "center",
              }}
            >
              封面
            </div>

            <Radio.Group
              onChange={this.radioChange}
              value={this.state.radioValue}
              size="large"
            >
              <Radio value={1}>单图</Radio>
              <Radio
                value={2}
                disabled={this.state.pictureList.length > 2}
              >
                三图
              </Radio>
              <Radio value={3}>自动</Radio>
            </Radio.Group>
          </div>

          <div
            style={{ display: "flex", alignItems: "center", marginTop: "30px" }}
          >
            <div>*</div>
            <div
              style={{
                margin: "0 20px 0 0",
                width: "80px",
                textAlign: "center",
              }}
            >
              选择栏目
            </div>

            <TreeSelect
              style={{ width: "100%" }}
              value={this.state.value3}
              dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
              treeData={treeData}
              showCheckedStrategy={SHOW_PARENT}
              treeDefaultExpandAll
              treeCheckable={true}
              onChange={(value) => {
                this.state.value3 = value;
                this.setState({});
              }}
            />
          </div>
          <div
            style={{
              marginLeft: "15px",
              marginTop: "30px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <div style={{ marginRight: "9px" }}>发布账号</div>
            <div style={{ margin: "0 20px" }}>
              <TreeSelect
                dropdownStyle={{ height: "100px" }}
                style={{ width: "200px" }}
                placeholder="请选择账号类型"
                value={this.state.value4}
                onChange={(value) => {
                  this.state.value4 = value;
                  this.setState({});
                  if (value === "单位发布") {
                    this.props.getEditorColumnLists();
                  } else if (value === "个人发布") {
                    this.props.getAllReports();
                  }
                }}
              >
                <TreeNode
                  value="请选择账号类型"
                  title="请选择账号类型"
                  key="0-1"
                />
                <TreeNode
                  value="单位发布"
                  title="单位发布"
                  key="0-2"
                />
                <TreeNode
                  value="个人发布"
                  title="个人发布"
                  key="0-3"
                />
              </TreeSelect>
            </div>
            <div>
              <TreeSelect
                dropdownStyle={{ height: "100px" }}
                style={{ width: "200px" }}
                placeholder="请选择账号"
                value={this.state.accountKey}
                treeData={
                  this.state.value4 === "单位发布"
                    ? this.props.editorColumnList
                    : this.state.value4 === "个人发布"
                      ? treeData3
                      : null
                }
                onChange={(value) => {
                  this.state.accountKey = value;
                  this.setState({});
                }}
              />
            </div>






          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Button onClick={this.store}>存为草稿</Button>
            <div style={{ marginLeft: "10px" }}>
              <Button type="primary" onClick={this.publish}>
                发布
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
  // 点击删除
  delete = (index) => {
    let pictureList = this.props.pictureList;
    pictureList.splice(index, 1);
    this.setState({
      pictureList,
    });
  };
  // // 点击存为草稿
  // store = () => {
  //   this.props.myAlter && this.props.myAlter(this.state.title);
  // };
  // //点击发布
  // publish = () => {
  //   let params = {
  //     labelNames: "" +
  //       "" +
  //       "" +
  //       "" +
  //       ",column_22",
  //     mfAccount: "218",
  //     mfAccountType: 2,
  //     mfId: "26",
  //     pictures: "",
  //     publishStatus: 1,
  //     title: "春暖花开，西安高新区永阳公园风景如画",
  //     type: "6",
  //   };
  // };
  // 标题改变
  titleChange = (e) => {
    this.setState({
      title: e.target.value,
    });
  };
  radioChange = (e) => {
    this.setState({
      radioValue: e.target.value,
    });
  };
  // // 点击发布时
  // getClickPublish() {
  //   let params = {
  //     labelNames: "column_21,column_22",
  //     mfAccount: "218",
  //     mfAccountType: 2,
  //     mfId: "26",
  //     pictures: "",
  //     publishStatus: 1,
  //     title: "春暖花开，西安高新区永阳公园风景如画",
  //     type: "6",
  //   };
  //   Actions.getPublish(params, (res) => {
  //     if (res) {
  //       message.success("发布成功");
  //       this.pageChange();
  //     } else {
  //       message.error("发布失败");
  //     }
  //   });
  // }
}
